// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    User,
    UserFromJSON,
    UserToJSON,
    UserMinified,
    UserMinifiedFromJSON,
    UserMinifiedToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestPlanComment
 */
export interface TestPlanComment {
    /**
     * 
     * @type {number}
     * @memberof TestPlanComment
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TestPlanComment
     */
    project?: number;
    /**
     * 
     * @type {number}
     * @memberof TestPlanComment
     */
    testPlan: number;
    /**
     * 
     * @type {Array<User>}
     * @memberof TestPlanComment
     */
    mentions?: Array<User>;
    /**
     * 
     * @type {number}
     * @memberof TestPlanComment
     */
    parentId?: number;
    /**
     * 
     * @type {string}
     * @memberof TestPlanComment
     */
    comment: string;
    /**
     * 
     * @type {UserMinified}
     * @memberof TestPlanComment
     */
    createdBy: UserMinified;
    /**
     * 
     * @type {string}
     * @memberof TestPlanComment
     */
    createdAt?: string;
}

export function TestPlanCommentFromJSON(json: any): TestPlanComment {
    return {
        'id': json['id'],
        'project': !exists(json, 'project') ? undefined : json['project'],
        'testPlan': json['test_plan'],
        'mentions': !exists(json, 'mentions') ? undefined : (json['mentions'] as Array<any>).map(UserFromJSON),
        'parentId': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'comment': json['comment'],
        'createdBy': UserMinifiedFromJSON(json['created_by']),
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
    };
}

export function TestPlanCommentToJSON(value?: TestPlanComment): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'project': value.project,
        'test_plan': value.testPlan,
        'mentions': value.mentions === undefined ? undefined : (value.mentions as Array<any>).map(UserToJSON),
        'parent_id': value.parentId,
        'comment': value.comment,
        'created_by': UserMinifiedToJSON(value.createdBy),
        'created_at': value.createdAt,
    };
}


